var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "login-page",
      on: {
        keyup: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          return _vm.login()
        },
      },
    },
    [
      _c("div", { staticClass: "brand-panel" }, [
        _c("img", {
          staticClass: "brand-bg-map",
          attrs: {
            src: require("../../assets/roadNetworkMap.svg"),
            alt: "",
            "aria-hidden": "true",
          },
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "brand-veil",
          attrs: { "aria-hidden": "true" },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "brand-coords" }, [
          _vm._v("42.4240° N · 83.4250° W"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "brand-content" }, [
          _c("p", { staticClass: "brand-tagline" }, [
            _vm._v("Map Management Platform"),
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "brand-features" }, [
            _c("li", [
              _c(
                "span",
                { staticClass: "brand-feature-icon" },
                [_c("fa", { attrs: { icon: ["fas", "layer-group"] } })],
                1
              ),
              _vm._v("\n          HD maps\n        "),
            ]),
            _vm._v(" "),
            _c("li", [
              _c(
                "span",
                { staticClass: "brand-feature-icon" },
                [_c("fa", { attrs: { icon: ["fas", "globe-americas"] } })],
                1
              ),
              _vm._v("\n          Global Geospatial Data\n        "),
            ]),
            _vm._v(" "),
            _c("li", [
              _c(
                "span",
                { staticClass: "brand-feature-icon" },
                [_c("fa", { attrs: { icon: ["fas", "eye"] } })],
                1
              ),
              _vm._v("\n          Precision\n        "),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "brand-footer" }, [
          _c(
            "a",
            {
              staticClass: "brand-legal",
              attrs: { href: "https://dmp-maps.com/legal/", target: "_blank" },
            },
            [
              _vm._v(
                "\n        © " +
                  _vm._s(new Date().getFullYear()) +
                  " Dynamic Map Platform North America, Inc.\n      "
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "popup-fade" } }, [
        _vm.showNewLookPopup
          ? _c("div", { staticClass: "new-look-popup" }, [
              _c(
                "button",
                {
                  staticClass: "new-look-close",
                  attrs: { title: "Close" },
                  on: { click: _vm.dismissNewLookPopup },
                },
                [_c("fa", { attrs: { icon: ["fas", "times"] } })],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "new-look-icon" },
                [_c("fa", { attrs: { icon: ["fas", "paint-brush"] } })],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "new-look-text" }, [
                _c("p", { staticClass: "new-look-title" }, [
                  _vm._v("Fresh new look incoming!"),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "new-look-body" }, [
                  _vm._v(
                    "We’re rolling out a redesigned MMP experience—stay tuned for updates."
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-panel" }, [
        _c("div", { staticClass: "form-stack" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "form-card" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "field-group" }, [
              _c("label", { staticClass: "field-label" }, [_vm._v("Email")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-wrap" },
                [
                  _c("fa", {
                    staticClass: "input-icon",
                    attrs: { icon: ["fas", "info-circle"] },
                  }),
                  _vm._v(" "),
                  _c("b-form-input", {
                    staticClass: "login-input",
                    attrs: {
                      type: "email",
                      name: "email",
                      placeholder: "you@example.com",
                    },
                    model: {
                      value: _vm.email,
                      callback: function ($$v) {
                        _vm.email = $$v
                      },
                      expression: "email",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "field-group" }, [
              _c("label", { staticClass: "field-label" }, [_vm._v("Password")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-wrap" },
                [
                  _c("fa", {
                    staticClass: "input-icon",
                    attrs: { icon: ["fas", "lock"] },
                  }),
                  _vm._v(" "),
                  _c("b-form-input", {
                    staticClass: "login-input",
                    attrs: {
                      type: _vm.passwordVisible ? "text" : "password",
                      name: "password",
                      placeholder: "••••••••",
                    },
                    model: {
                      value: _vm.password,
                      callback: function ($$v) {
                        _vm.password = $$v
                      },
                      expression: "password",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "eye-toggle",
                      attrs: {
                        title: _vm.passwordVisible
                          ? "Hide password"
                          : "Show password",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.togglePasswordVisibility()
                        },
                      },
                    },
                    [
                      _c("fa", {
                        attrs: {
                          icon: [
                            "fas",
                            _vm.passwordVisible ? "eye-slash" : "eye",
                          ],
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "forgot-row" },
              [
                _c(
                  "b-link",
                  {
                    staticClass: "forgot-link",
                    on: {
                      click: function ($event) {
                        return _vm.forgotPassword()
                      },
                    },
                  },
                  [_vm._v("Forgot password?")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "login-btn",
                on: {
                  click: function ($event) {
                    return _vm.login()
                  },
                },
              },
              [_vm._v("\n        Sign In\n        ")]
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "form-logo-link",
        attrs: { href: "https://www.ushrauto.com/", target: "_blank" },
      },
      [
        _c("img", {
          staticClass: "form-logo",
          attrs: {
            src: require("../../assets/dmpLogin.png"),
            alt: "Dynamic Map Platform",
          },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "form-header" }, [
      _c("h2", { staticClass: "form-title" }, [_vm._v("Welcome back")]),
      _vm._v(" "),
      _c("p", { staticClass: "form-subtitle" }, [
        _vm._v("Sign in to your account to continue"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }